import Vue from 'vue';
import Vuex from 'vuex';
import collect from 'collect.js';
import sections from './modules/sections';
import products from './modules/products';
import spinner from './modules/spinner';
import * as productTypes from './modules/products/mutation-types';
import * as sectionsTypes from './modules/sections/mutation-types';
import * as types from './mutation-types';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        dataLoaded: false,
        currentInfoPanel: null,
        currentHotspot: ''
    },
    mutations: {
        [types.DATA_LOADED](state, loaded) {
            state.dataLoaded = loaded;
        },

        [types.CURRENT_INFO_PANEL](state, currentInfoPanel) {
            state.currentInfoPanel = currentInfoPanel;
        },

        [types.CURRENT_HOTSPOT](state, currentHotspot) {
            state.currentHotspot = currentHotspot;
        }
    },
    modules: {
        sections,
        products,
        spinner
    },
    actions: {
        loadData({ commit }) {
            const basePath =
                process.env.NODE_ENV === 'production' && process.env.VUE_APP_MODE !== 'electron'
                    ? '/product-interactive/'
                    : '/';
            axios.get(`${basePath}data/app.json`).then(response => {
                let products = collect(response.data.products);
                let sections = collect(response.data.sections)
                    .map(item => {
                        if (item.products) {
                            item.children = collect(item.products)
                                .map(product => {
                                    const found = products
                                        .where('id', product)
                                        .first();
                                    return {
                                        name: found.name,
                                        route: found.id
                                    };
                                })
                                .all();
                        }
                        return item;
                    })
                    .all();
                commit('sections/' + sectionsTypes.SECTIONS, sections);
                commit(
                    'products/' + productTypes.PRODUCTS,
                    response.data.products
                );

                commit(types.DATA_LOADED, true);
            });
        },

        setCurrentInfoPanel({ dispatch, commit, state }, params) {
            if (state.dataLoaded) {
                if (params instanceof Object && params.module && params.name) {
                    dispatch(`${params.module}/getInfoPanel`, params.name)
                        .then(panel => {
                            commit(types.CURRENT_INFO_PANEL, panel);
                            commit(types.CURRENT_HOTSPOT, '');
                        })
                        .catch(() => {
                            // eslint-disable-next-line no-console
                            console.log('no panel');
                        });
                } else if (params instanceof Object) {
                    commit(types.CURRENT_INFO_PANEL, null);
                    commit(types.CURRENT_HOTSPOT, '');
                }
            } else {
                setTimeout(() => {
                    dispatch('setCurrentInfoPanel', params);
                }, 500);
            }
        },

        setCurrentHotspot({ commit, dispatch }, name) {
            if (name) {
                dispatch('spinner/setCurrentHotspot', name);
                name = name.replace('sprite_', '');
            }
            commit(types.CURRENT_HOTSPOT, name);
        }
    }
});
